import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

function Nav() {
  return (
    <nav className="nav">
      <div className="nav-links">
        <Link to="/">home</Link>
        <Link to="/blog">blog</Link>
        <Link to="/more">more</Link>
      </div>
      <div className="nav-icons">
        <a
          href="https://www.linkedin.com/in/trevorharless/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FontAwesomeIcon icon={faLinkedin} size="lg" color="#181717" />
        </a>
        <a
          href="https://github.com/trevorharless"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
        >
          <FontAwesomeIcon icon={faGithub} size="lg" color="#181717" />
        </a>
        <a href="mailto:trevorharless.dev@gmail.com" aria-label="Email">
          <FontAwesomeIcon icon={faEnvelope} size="lg" color="#181717" />
        </a>
      </div>
    </nav>
  );
}

export default Nav;
